import iFrameCssClasses from "../constants/iFrameCssClasses";

import getElementByXpath from "./getElementByXpath";

const highlightElement = (iframeRef, xpath, className) => {
    let elements;

    if(Array.isArray(xpath)) {
        elements = xpath.reduce(
            (acc, itemXpath) => {
                const newArr = getElementByXpath(iframeRef, itemXpath, iFrameCssClasses.active);

                if(Array.isArray(newArr)) {
                    return [ ...acc, ...newArr ];
                }

                return acc;
            },
            []
        );
    } else {
        elements = getElementByXpath(iframeRef, xpath);
    }

    if(!elements || !elements.length) {
        return;
    }

    elements.forEach((element) => {
        element.classList.add(className);
    });
};

export default highlightElement;
